<p class="font-medium text-2xl text-center pt-10">
  Research and Data Collection
</p>
<div class="flex flex-col items-center mx-[30px] lg:mx-[45px] lg:mx-8">
  <p class="font-medium mb-5">
    You can choose to participate in any or all of them
  </p>
  <div class="flex flex-col w-full pr-3 h-[25rem] lg:h-[35rem] overflow-auto overflow-x-hidden">
    <ul>
      @for (item of data; track item; let i = $index) {
        <mat-accordion class="flex">
          <mat-checkbox [checked]="item.completed" (change)="change($event.checked, i)" class="p-3"></mat-checkbox>
          <mat-expansion-panel [togglePosition]="'before'" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{item.name}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (checkForHTMLTags(item.agreement_text)) {
              <p [innerHTML]="item.agreement_text"></p>
            }
            @if (!checkForHTMLTags(item.agreement_text)) {
              <p [innerText]="item.agreement_text"></p>
            }
          </mat-expansion-panel>
        </mat-accordion>
      }
    </ul>
  </div>
</div>
<div class="flex justify-around mt-7">
  <mat-checkbox (change)="selectAll($event.checked)" [checked]="allComplete" [indeterminate]="someComplete()">
    Select All
  </mat-checkbox>
  <button mat-flat-button color="primary" class="text-md" (click)="continue()">
    Accept and Continue
  </button>
</div>
